export default __webpack_public_path__ + "5ea07fdae7903c93e6ded59cb50db441.png";